import React from "react"
import Table from "react-bootstrap/Table"

import CrowdLampHandler from "../Places/CrowdLampHandler"
import PublishHandler from "../Places/PublishHandler"
import Alerts from "../../Alerts"
import Icon from "../../Utils/Icon"

import styles from "./Styles/Places.module.scss"
import {
  contactMail,
  contactPhone,
  businessHours,
  businessWeekdays,
} from "../Support"

const ShelterArea = (props) => {
  if (!props.shelter || !props.shelter.areas) {
    return <React.Fragment />
  }
  return (
    <React.Fragment>
      {props.shelter.areas.map((area, i) => (
        <div key={i}>
          <a href={area.path} target="_blank">
            {area.name}
            <Icon
              type="feather"
              name="external-link"
              attr={{ width: 16, height: 16 }}
              className={styles.externalLink}
            />
          </a>
        </div>
      ))}
    </React.Fragment>
  )
}

const Places = (props) => {
  const places = JSON.parse(props.editablePlaces)
  return (
    <div className={styles.page}>
      <Alerts error={props.error} notice={props.notice} />
      <section className={styles.content}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>編集可能な施設一覧</h1>
          <a href="/settings">
            <Icon
              type="feather"
              name="settings"
              attr={{ width: 18, height: 18 }}
              className={styles.externalLink}
            />
            アカウント設定
          </a>
        </div>
        <hr />
        <Table striped bordered hover responsive className={styles.table}>
          <thead>
            <tr>
              <th>施設名</th>
              <th>避難所区域</th>
              <th>混雑ランプ</th>
              <th>公開ステータス</th>
            </tr>
          </thead>
          <tbody className={styles.body}>
            {places.map((place, i) => (
              <React.Fragment key={i}>
                <tr>
                  <td>
                    <a href={place.path}>{place.name}</a>
                  </td>
                  <td>
                    <ShelterArea shelter={place.shelter} />
                  </td>
                  <td>
                    <CrowdLampHandler
                      placeId={place.id}
                      lamp={place.lamp}
                      available={place.authorities.includes(
                        place.shelter ? "shelter" : "lamp"
                      )}
                      isShelter={!!place.shelter}
                    />
                  </td>
                  <td>
                    <PublishHandler
                      placeId={place.id}
                      published={!!place.publishedAt}
                    />
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </section>
      <section className={styles.footer}>
        <h3>サポート窓口</h3>
        <div className={styles.contactInfo}>
          <div>
            <Icon
              className={styles.contactIcon}
              type="feather"
              name="phone"
              attr={{ width: 14, height: 14 }}
            />
            <span>{contactPhone}</span>
          </div>
          <div>
            <Icon
              className={styles.contactIcon}
              type="feather"
              name="mail"
              attr={{ width: 14, height: 14 }}
            />
            <a href={`mailto:${contactMail}`}>{contactMail}</a>
          </div>
          <div>{`受付時間: ${businessWeekdays} ${businessHours}`}</div>
        </div>
      </section>
    </div>
  )
}

export default Places
